export default __webpack_public_path__ + "static/media/dashboardhome1.c04d8190.jpg";